import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ValidateUniqueColumnAndUpdateRespondentRPC } from "./validateUniqueColumnAndUpdateRespondentRPC";

export class ValidateUniqueColumnAndUpdateRespondentRPCClientImpl extends ValidateUniqueColumnAndUpdateRespondentRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ValidateUniqueColumnAndUpdateRespondentRPC.Request): Promise<LeoRPCResult<ValidateUniqueColumnAndUpdateRespondentRPC.Response, ValidateUniqueColumnAndUpdateRespondentRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/ValidateUniqueColumnAndUpdateRespondent",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ValidateUniqueColumnAndUpdateRespondentRPC.ResponseDTO,
      ValidateUniqueColumnAndUpdateRespondentRPC.Errors.ErrorsDTO,
      ValidateUniqueColumnAndUpdateRespondentRPC.Response,
      ValidateUniqueColumnAndUpdateRespondentRPC.Errors.Errors
    >(
      response,
      "respondent/ValidateUniqueColumnAndUpdateRespondent",
      ValidateUniqueColumnAndUpdateRespondentRPC.Response.fromDTO,
      ValidateUniqueColumnAndUpdateRespondentRPC.Errors.fromDTO
    );
  }
}
